var React = require('react');

function IconAccountInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(1)","stroke":"currentColor","strokeWidth":"2","fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"cx":"9","cy":"6","r":"5","key":0}),React.createElement("path",{"d":"M18 23a9 9 0 0 0-18 0","strokeLinecap":"round","strokeLinejoin":"round","key":1})]));
}

IconAccountInline.defaultProps = {"width":"20","height":"24","viewBox":"0 0 20 24"};

module.exports = IconAccountInline;

IconAccountInline.default = IconAccountInline;
